module.exports = __webpack_public_path__ + "img/高碑店箱包.4ba4085d.jpg";